angular.module('skeyenoteWebApp').directive('interpreterItem', InterpreterItemDirective);

function InterpreterItemDirective($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element, attr) {
      if (scope.$last === true) {
        $timeout(function() {
          let id = 'ngRenderFinished';
          scope.$emit(id);
        });
      }
    },
  };
}
